import React from "react";

/* Cite-ready quick answer box + last-reviewed date for guides/articles. */
export const QuickAnswer = ({ children, reviewed = "June 2026" }) => (
  <div
    data-testid="quick-answer"
    className="bg-[#E8F0EB] border border-[#2B5339] rounded-2xl p-5 mt-8"
  >
    <div className="flex items-center justify-between gap-3 mb-2">
      <div className="text-[10px] tracking-[0.2em] uppercase font-semibold text-[#2B5339]">
        Quick answer
      </div>
      <div className="text-[10px] text-[#5C6B62]">Last reviewed: {reviewed}</div>
    </div>
    <p className="text-sm sm:text-base text-[#1C2B23] leading-relaxed m-0">{children}</p>
  </div>
);

export default QuickAnswer;
